import { render } from "./ServicesCarousel.vue?vue&type=template&id=e9c95942&scoped=true&ts=true"
import script from "./ServicesCarousel.vue?vue&type=script&lang=ts"
export * from "./ServicesCarousel.vue?vue&type=script&lang=ts"

import "./ServicesCarousel.vue?vue&type=style&index=0&id=e9c95942&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9c95942"]])

export default __exports__